import React from 'react';

const IconLayoutTwo = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="89"
            height="89"
            viewBox="0 0 89 89"
            fill="none"
        >
            <g filter="url(#filter0_d_5851_16052)">
                <path
                    d="M2 6.23153C2 3.89452 3.89452 2 6.23152 2H80.9236C83.2606 2 85.1551 3.89452 85.1551 6.23152V80.9236C85.1551 83.2606 83.2606 85.1551 80.9236 85.1551H6.23153C3.89452 85.1551 2 83.2606 2 80.9236V6.23153Z"
                    shape-rendering="crispEdges"
                />
                <rect
                    x="22.041"
                    y="64"
                    width="15.9388"
                    height="41.3469"
                    transform="rotate(-90 22.041 64)"
                    stroke="#303030"
                    stroke-opacity="0.5"
                />
                <rect
                    x="22.041"
                    y="39.4395"
                    width="15.9388"
                    height="41.3469"
                    transform="rotate(-90 22.041 39.4395)"
                    stroke="#303030"
                    stroke-opacity="0.5"
                />
            </g>
        </svg>
    );
};

export default IconLayoutTwo;
